import React from "react";

const RequiredMark = ({ className = "required-mark" }) => {
	return <span className={className}>*</span>;
};

export default RequiredMark;
